$(document).ready(function () {

  //benefits-slick
  $('.benefits-slick').slick({
    lazyLoad: 'progressive',
    dots: false,
    infinite: false,
    adaptiveHeight: false,
    rows: 4,
    slidesPerRow: 2,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          adaptiveHeight: false,
          dots: true,
          infinite: true,
          rows: 1,
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]

  })

  $('.slick-slide').children().addClass('d-md-flex');

  $('.how-it-works-slider').slick({
    lazyLoad: 'progressive',
    dots: false,
    infinite: false,
    rows: 3,
    slidesPerRow: 1,
    responsive: [
        {
        breakpoint: 768,
        settings: {
          dots: true,
          infinite: true,
          rows: 1,
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1
        }
        }
    ]

  });
});
